export default "__VITE_ASSET__DgJrcaF5__"